import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as Actions from "../../constants/baseUrl";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: Actions.AUTH_URL }),
  endpoints: () => ({}),
});

export const loginApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    googleLogin: builder.mutation({
      query: (login) => ({
        url: "Auth/google-login",
        method: "POST",
        body: login,
      }),
    }),
    linkedInLogin: builder.mutation({
      query: (login) => ({
        url: "Auth/linkedin-login",
        method: "POST",
        body: login,
      }),
    }),
    refreshToken: builder.mutation({
      query: (refreshToken) => ({
        url: "Auth/refresh-token",
        method: "POST",
        body: refreshToken,
      }),
    }),
  }),
});

export const {
  useGoogleLoginMutation,
  useLinkedInLoginMutation,
  useRefreshTokenMutation,
} = loginApi;
